var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.772 18V9.106q0-3.636 1.948-5.965Q14.67.811 18 0v3.918q-1.027.317-1.665.811a3.4 3.4 0 0 0-.993 1.095q-.355.634-.46 1.482a14 14 0 0 0-.106 1.8v.988H18V18zM0 18V9.106Q0 5.47 1.949 3.14 3.898.811 7.229 0v3.918q-1.028.317-1.666.811a3.4 3.4 0 0 0-.992 1.095 5.2 5.2 0 0 0-.46 1.482q-.107.812-.107 1.8v.988h3.224V18z"
  })));
};
export default SvgQuotes;